<script setup lang="ts">
  import { computed, nextTick, onMounted, onUnmounted, ref } from 'vue';

  import FeatureEnrollmentContent from './FeatureEnrollmentContent.vue';
  import FeatureEnrollmentFooter from './FeatureEnrollmentFooter.vue';
  import FeatureEnrollmentHeader from './FeatureEnrollmentHeader.vue';
  import { HEADER_MAX_HEIGHT, HEADER_MIN_HEIGHT, useFeatureEnrollmentProvider } from './FeatureEnrollmentLayout.vue';

  const { slots, alertRef, bodyRef } = useFeatureEnrollmentProvider();

  const dynamicContentMarginBottom = ref('0px');
  const dynamicAlertSlotWrapperHeight = ref('0px');

  const dynamicContentGridTemplateRows = computed(() => {
    const templateRows = 'auto 1fr auto';
    return slots?.alert ? `auto ${templateRows}` : templateRows;
  });

  const onWindowResize = async () => {
    if (bodyRef.value) {
      dynamicContentMarginBottom.value = '0px';

      await nextTick();

      const scrollRange = bodyRef.value.scrollHeight - bodyRef.value.clientHeight;
      const scrollRangeLimit = HEADER_MAX_HEIGHT - HEADER_MIN_HEIGHT;

      if (scrollRange > 0 && scrollRange < scrollRangeLimit) {
        dynamicContentMarginBottom.value = scrollRangeLimit - scrollRange + 'px';
      }
    }

    if (alertRef.value) {
      dynamicAlertSlotWrapperHeight.value = alertRef.value.clientHeight + 'px';
    }
  };

  onMounted(() => {
    window.addEventListener('resize', onWindowResize);
    onWindowResize();
  });

  onUnmounted(() => {
    window.removeEventListener('resize', onWindowResize);
  });
</script>

<template>
  <main
    class="tw-grid tw-h-screen tw-overflow-y-auto tw-z-content"
    :style="{
      gridTemplateRows: dynamicContentGridTemplateRows,
    }"
    ref="bodyRef"
  >
    <div v-if="slots?.alert" class="tw-sticky tw-top-0 tw-z-dialog" ref="alertRef">
      <component :is="slots.alert" />
    </div>

    <FeatureEnrollmentHeader
      class="tw-sticky tw-z-control"
      :style="{
        top: dynamicAlertSlotWrapperHeight,
      }"
    />

    <div
      class="tw-z-content"
      :style="{
        marginBottom: dynamicContentMarginBottom,
      }"
    >
      <FeatureEnrollmentContent />
    </div>

    <FeatureEnrollmentFooter class="tw-z-control" />
  </main>
</template>
